import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import {
    Chart,
    RadarController,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
} from 'chart.js';
import { useParams } from "react-router-dom";
import axios from "axios";
import Subscriptions from "../Subscriptions/Subscriptions";
import "../DarkResult/DarkResult.css"
import "../FinalPage/FinalPage.css";


import Dashboard from '../Dashboard/Dashboard'
import dark from "../../images/dark.png"
import black from "../../images/black.png"
import darkstand from "../../images/dark-stand.png"
import darksit from "../../images/dark-sit.png"
import { END_URL, IMG_URL } from "../../config";
import ProgressBarNew from '../ProgressBarNew/ProgressBarNew';
import ResultTwo from '../ResultTwo/ResultTwo'
import ResultPageLast from '../ResultPageLast/ResultPageLast';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import loadimg from "../../images/loader_wish.gif";
import ResultChart from '../ResultChart/ResultChart';
import buttonloader from "../../images/buttonloader.gif";


function DarkEmailResults({ plan, onLoginChange, result, testdata, demension, globaltest }) {


    const [ButtonLoad, setButtonLoad] = useState(false);
    // const [tests, setTests] = useState([]);
    const chartRef = useRef(null);

    const { slug, test_slug } = useParams();


    const LocalTest = JSON.parse(localStorage.getItem(slug));

    const [testData, settestData] = useState([]);

    const [Result, setResult] = useState('');

    const [Demension, setDemension] = useState([]);

    const [Cluster, setCluster] = useState([]);

    const [getBladge, setgetBladge] = useState([]);

    const [BladgeDimension, setBladgeDimension] = useState([]);

    const token = localStorage.getItem('token');
    const [selectedLabel, setSelectedLabel] = useState(null);
    const [selectedPercentage, setSelectedPercentage] = useState(null);
    const navigate = useNavigate();
    const user = localStorage.getItem('user');
    const [TestData, setTestData] = useState(testdata);
    const [SubPlan, setSubPlan] = useState({});

    const [hasSubscription, setHasSubscription] = useState(false);

    const [hasplan, setHasPlan] = useState({});
    const [resultDetails, setResultDetails] = useState([]);

    const [ChartLabel, setChartLabel] = useState([]);


    const TestSaved = localStorage.getItem(`test_${LocalTest?.test?.id}`);
    const canvasRef = useRef(null);


    const [Opacity, setOpacity] = useState(true);

    const [Subcription, setSubcription] = useState([]);

    const [TestSubcription, setTestSubcription] = useState([]);

    const [TestResut, setTestResut] = useState([]);

    const [SavedTest, setSavedTest] = useState(false);

    const [resultReady, setResultReady] = useState(false);

    const [isLoading, setIsLoading] = useState(true);

    const [HavePastTest, setHavePastTest] = useState(false);

    const result_letter = useMemo(() => {
        return testData?.data?.map((item) => ({
            final_letter: item.letter === 'left' ? item.leftletter : item.rightletter,
        })) || [];
    }, [testData]);


    useEffect(() => {

        setTestData(testdata);
    }, [testdata]);


    useEffect(() => {

        if (!SavedTest) {
            settestData(LocalTest);
        }

        if (SavedTest) {

            FetchUserResult();
        }

    }, [SavedTest]);



    const FetchUserResult = async () => {

        try {

            const response = await fetch(`${END_URL}/user-resultdark`, {

                method: "POST",
                headers: {

                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    slug: slug
                })
            });

            const data = await response.json();

            const result = data?.data?.result;

            const test = {
                test: {
                    id: data.test.id,
                    name: data.test.name,
                    type: data.test.type,
                    slug: data?.test?.slug || "",
                    test_slug: data?.data?.test_slug || "",
                    result_test_name:  data.test.result_test_name || ""
                }
            };


            const resultdata = {

                data: data?.data?.categoryresult?.map((item, index) => ({
                    category_id: item.id,
                    left_result: item.left_result,
                    leftlabel: item.resultcategory.left_label,
                    leftletter: item.resultcategory.leftletter,
                    letter: item.letter,
                    name: item.name,
                    right_result: item.right_result,
                    rightlabel: item.resultcategory.right_label,
                    rightletter: item.resultcategory.rightletter,
                }))
            };

            const ConvertedtestData = {
                ...resultdata,
                result: result,
                ...test
            };

            settestData(ConvertedtestData);

        } catch (error) {

            console.error("Error sending result:", error);
        }
    };


    useEffect(() => {

        const SubcriptionDetail = async () => {

            try {

                const response = await axios.get(`${END_URL}/get-subcription`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                const reponsedata = response?.data;

                setSubcription(reponsedata);



            }
            catch {
                console.log('some error ');
            }

        };

        SubcriptionDetail();
    }

        , []);


    useEffect(() => {

        if (user) {

            SaveTest();
        }

        if (!user) {
            setTimeout(() => {

                window.scrollTo({ top: 0, behavior: 'smooth' });
                onLoginChange(true);
            }, 5000);
        }

        checkSubcription();

    }, [user, testData]);

    const checkSubcription = async () => {

        try {

            const response = await axios.post(`${END_URL}/check-subcription`,
                { slug: slug },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                });

            const subcription = response.data.subcription;

            const plan = response.data.test_sub;

            setSubPlan(plan);
            if (subcription > 0) {
                setOpacity(false);
            }

            console.log('check subcription', subcription);
            console.log('Plan received from APIs:', plan);


        } catch (error) {

            console.error("Error sending result:", error);
        }

    };



    const HandlePayment = (item) => {

        const InitializePayment = async () => {

            try {

                setButtonLoad(true);

                const response = await fetch(`${END_URL}/test-payment`, {

                    method: "POST",
                    headers: {

                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify(item)

                });

                const data = await response.json();

                console.log(data.payment, 'fetch data');


                if (data.payment) {

                    setButtonLoad(false);
                    window.location.href = data.payment;

                } else {

                     setButtonLoad(false);
                     
                    console.error("Invalid response:", data);
                    alert("An error occurred while processing the request.");
                }

            } catch (error) {

                console.error("Error sending result:", error);
            }
        };

        InitializePayment();

    };




    const SaveTest = async () => {

        try {

            const response = await axios.post(`${END_URL}/submit/test/${slug}/${test_slug}`, LocalTest, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            const testsave = response?.data.saved;

            console.log('saved text', testsave);

            setSavedTest(testsave);

        } catch (error) {

            console.error("Error sending result:", error);
        }

    };

    useEffect(() => {
        if (Array.isArray(testData?.data) && testData?.data?.length > 0) {
            const chartfilter = testData?.data?.map((item) => ({
                label: item.letter === "left" ? item.leftlabel : item.rightlabel,
                percentage: item.letter === "left" ? item.left_result : item.right_result,
            }));

            setChartLabel(chartfilter);

            setSelectedLabel(chartfilter[0]?.label);
            setSelectedPercentage(Math.round(chartfilter[0]?.percentage));
        }

    }, [testData]);




    useEffect(() => {
        Chart.register(
            RadarController,
            RadialLinearScale,
            PointElement,
            LineElement,
            Filler,
            Tooltip,
            Legend
        );

        if (!canvasRef.current) return;
        const ctx = canvasRef.current.getContext('2d');

        if (chartRef.current) {
            chartRef.current.destroy();
        }

        chartRef.current = new Chart(ctx, {
            type: 'radar',
            data: {
                labels: ChartLabel.map((item) => item.label),
                datasets: [{
                    data: ChartLabel.map((item) => Math.round(item.percentage)),
                    backgroundColor: '#86a191',
                    borderColor: '#ffec8870',
                    borderWidth: 2,
                    pointBackgroundColor: '#ffec8870',
                    pointBorderColor: '#ffec8870'
                }]
            },
            options: {
                responsive: true,
                onClick: (event, elements) => {
                    if (elements.length > 0) {
                        const index = elements[0].index;
                        setSelectedLabel(ChartLabel[index].label);
                        setSelectedPercentage(Math.round(ChartLabel[index].percentage));
                    }
                },
                plugins: {
                    title: {
                        display: true,
                        text: "",
                        font: {
                            size: 18
                        },
                        color: '#657aed'
                    },
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: true
                    }
                },
                scales: {
                    r: {
                        angleLines: {
                            display: true
                        },
                        ticks: {
                            backdropColor: '#fff8d3',
                            color: '#6d6d6d'
                        },
                        suggestedMin: 0,
                        suggestedMax: 100
                    }
                }
            }
        });

        return () => {
            if (chartRef.current) {
                chartRef.current.destroy();
            }
        };
    }, [ChartLabel]);




    useEffect(() => {

        if (Array.isArray(result_letter) && result_letter.length > 0) {

            const finalResult = result_letter.map((item) => item.final_letter).join("");

            setResult(finalResult);

        } else {
            setResult('');
        }
    }, [result_letter]);





    useEffect(() => {

        setIsLoading(true);

        FetchResultData();
    }, []);

    useEffect(() => {

        console.log("Demension updated:", Demension);
        if (Demension && typeof Demension === 'object' && Object.keys(Demension).length > 0) {
            setResultReady(true);
        }
    }, [Demension]);

    const FetchResultData = async () => {

        try {

            const response = await fetch(`${END_URL}/result-clusterdark/${slug}/${test_slug}`, {

                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            const data = await response.json();

            setDemension(data?.dimensions);

            setCluster(data.cluster);

            setgetBladge(data.bladge);

            setHavePastTest(data.have_past_test);

            setBladgeDimension(data.dimension_data);

            setResultDetails(data.result_details);

        } catch (error) {

            console.error("Error sending result:", error);
        }
        finally {

            setIsLoading(false);
        }
    };



    // if (!testData) {

    //     return <p>Loading...</p>;
    // }

    console.log(testData, 'saving test console');


    const testsubscription = testData?.test?.type;

    const typetest = testsubscription === 'free_test' ? 'type_1' : testsubscription;

    const subplan = Subcription?.data?.filter((item) => {
        return item.type === typetest;
    });

    console.log(subplan, 'Filtered subscription plan');




    const colors = ["purple", "#daa520", "#3fa8eb", "#19bbab", "#ff8183", "#b8f976"];




    useEffect(() => {
        const checkSlugSubscription = async () => {
            try {
                const response = await axios.get(`${END_URL}/subscription/check/${slug}/${test_slug}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                setHasSubscription(response.data.has_subscription);

                setHasPlan(response.data.plan);

            } catch (error) {
                setHasSubscription(false);
            }
        };

        checkSlugSubscription();
    }, [user, token]);


    const waitForImages = (element) => {
        const images = element.querySelectorAll('img');
        return Promise.all(
            Array.from(images).map(img => {
                if (!img.complete) {
                    return new Promise((resolve) => {
                        img.onload = resolve;
                        img.onerror = resolve;
                    });
                }
                return Promise.resolve();
            })
        );
    };

    // const generateAndStorePDF = async () => {
    //     const input = document.getElementById('result-cont');
    //     if (!input) {
    //         console.error('Result container not found. Make sure your main result div has id="result-cont"');
    //         return;
    //     }

    //     try {
    //         // Wait for images to load
    //         await waitForImages(input);

    //         const originalScrollY = window.scrollY;
    //         const originalScrollX = window.scrollX;

    //         // Style the container for screenshot
    //         input.style.position = 'absolute';
    //         input.style.top = '0px';
    //         input.style.left = '0px';
    //         input.style.width = '100%';
    //         input.style.zIndex = '9999';
    //         input.style.overflow = 'visible';
    //         window.scrollTo(0, 0);

    //         // Capture the container as an image
    //         const canvas = await html2canvas(input, {
    //             scale: 0.6,
    //             width: input.scrollWidth,
    //             height: input.scrollHeight,
    //             logging: false,
    //             useCORS: true,
    //             windowWidth: input.scrollWidth,
    //             windowHeight: input.scrollHeight,
    //             scrollX: 0,
    //             scrollY: 0,
    //         });

    //         // Restore original styles and scroll
    //         input.style.position = '';
    //         input.style.top = '';
    //         input.style.left = '';
    //         input.style.width = '';
    //         input.style.zIndex = '';
    //         input.style.overflow = '';
    //         window.scrollTo(originalScrollX, originalScrollY);

    //         // Create PDF
    //         const pdf = new jsPDF('p', 'mm', 'a4');
    //         const imgWidth = 210; // A4 width in mm
    //         const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //         const pageHeight = 297; // A4 height in mm

    //         let position = 0;
    //         while (position < canvas.height) {
    //             const sliceHeight = Math.min(
    //                 canvas.height - position,
    //                 (pageHeight * canvas.width) / imgWidth
    //             );

    //             const sliceCanvas = document.createElement('canvas');
    //             sliceCanvas.width = canvas.width;
    //             sliceCanvas.height = sliceHeight;
    //             const ctx = sliceCanvas.getContext('2d');
    //             ctx.drawImage(
    //                 canvas,
    //                 0, position,
    //                 canvas.width, sliceHeight,
    //                 0, 0,
    //                 canvas.width, sliceHeight
    //             );

    //             const sliceImgData = sliceCanvas.toDataURL('image/jpeg', 0.7);

    //             if (position > 0) pdf.addPage();

    //             pdf.addImage(
    //                 sliceImgData,
    //                 'JPEG',
    //                 0, 0,
    //                 imgWidth, (sliceHeight * imgWidth) / canvas.width
    //             );

    //             position += sliceHeight;
    //         }

    //         // Generate blob and send to server
    //         const pdfBlob = pdf.output('blob');
    //         const formData = new FormData();
    //         formData.append('pdf', pdfBlob, 'result.pdf');
    //         formData.append('slug', slug);
    //         formData.append('token', token);

    //         await axios.post(`${END_URL}/store-pdf`, formData, {
    //             headers: {
    //                 Authorization: `Bearer ${token}`,
    //                 'Content-Type': 'multipart/form-data',
    //             },
    //         });

    //         alert('PDF sent successfully to your registered email.');
    //     } catch (error) {
    //         console.error('PDF generation error:', error);
    //         alert('Failed to generate or send PDF. Please try again.');
    //     }
    // };

    return (
        <div className="dark-main" id="result-cont">


            {(isLoading || !resultReady) && test_slug !== 'start' ? (

                <div className="loader-container">

                    <img src={loadimg} alt="Loading..." className="loader-gif" />

                </div>

            ) : (

                <>
                    {Demension && Object.keys(Demension).length > 0 &&

                        <div className="container-fluid dark-fluid1">

                            <div className="row">
                                <div className="dark-col"></div>
                                <div className="row dark-row">
                                    <div className="col-12 col-md-7">
                                        <h1>
                                            {Demension?.name} <span>{Result?.split('').join(' ')}</span>
                                        </h1>
                                        <p>{Demension?.description}</p>
                                    </div>
                                    <div className="col-12 col-md-3">
                                        <img src={`${IMG_URL}/d0/${Demension?.image}`} alt="" />
                                    </div>
                                </div>
                            </div>

                        </div>
                    }


                    <div className="container-fluid dark-fluid2 darkfluid-21 full-width">

                        <div className="row">

                            {/* dark-res */}
                            <div className="col-12 col-sm-12 col-md-8 col-lg-8  ">

                                <div className="dark-inner-outer">


                                    {resultDetails && resultDetails.length > 0 &&
                                        <>

                                            <div className="dark-repeater final-col final-col-inner">
                                                {resultDetails.map((item) => (

                                                    < div className={`final-part1 ${item.content_type}`} key={item.id} dangerouslySetInnerHTML={{ __html: item.content }} />
                                                ))}

                                            </div>


                                            <ResultTwo   test_id={testData?.test?.id} />

                                            <ResultChart onLoginChange={onLoginChange} past_test={HavePastTest} subplan={subplan} token={token} result={result_letter} testdata={testData} demension={Demension} opacity={Opacity} />

                                        </>
                                    }

                                </div>

                                {/* {testData && (
                                    <button onClick={generateAndStorePDF} className="btn-pdf-darkp">
                                        Send as PDF
                                        <span className="">
                                            <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                        </span>
                                    </button>
                                )} */}

                            </div>

                        </div>

                    </div>


                    {/* {testData && ( 
                <button onClick={generateAndStorePDF} className="btn-pdf">
                    Send as PDF
                </button>
            )} */}

                </>

            )}

        </div>
    )
}

export default DarkEmailResults